import { render, staticRenderFns } from "./ModuleOptionsDropdown.vue?vue&type=template&id=22b26a6a"
import script from "./ModuleOptionsDropdown.vue?vue&type=script&lang=js"
export * from "./ModuleOptionsDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports